import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { readZavvyRole } from '../../Components/FocusMode/Zavvy/role';
import { zavvyUsage } from '../../Api/ZavvyApi';

const VIEWS = [
  ['summary', 'Overview', zavvyUsage.summary],
  ['byOrg', 'By organisation', zavvyUsage.byOrg],
  ['byUser', 'By user and role', zavvyUsage.byUser],
  ['byAgent', 'By agent and model', zavvyUsage.byAgent],
  ['routines', 'Routines', zavvyUsage.routines],
  ['quality', 'Quality', zavvyUsage.quality],
  ['retention', 'Retention', zavvyUsage.retention],
  ['external', 'External MCP', zavvyUsage.externalMcp],
];

export default function TrinityZavvyUsage() {
  const role = readZavvyRole();
  const [view, setView] = useState('summary');
  const [data, setData] = useState(null);
  const [limits, setLimits] = useState(null);
  const [prices, setPrices] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!role.superAdmin) return;
    const spec = VIEWS.find((row) => row[0] === view);
    spec[2]().then((res) => setData(res.data)).catch((err) => setError(err?.response?.status === 403 ? 'Super Admin only' : 'Could not load usage'));
  }, [view, role.superAdmin]);

  useEffect(() => {
    if (!role.superAdmin) return;
    zavvyUsage.limits().then((res) => setLimits(res.data)).catch(() => {});
    zavvyUsage.prices().then((res) => setPrices(res.data)).catch(() => {});
  }, [role.superAdmin]);

  if (!role.superAdmin) {
    return <Typography>Zavvy usage is limited to Super Admin.</Typography>;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">Zavvy usage</Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', my: 2 }}>
        {VIEWS.map(([id, label]) => (
          <Button key={id} size="small" variant={view === id ? 'contained' : 'outlined'} onClick={() => setView(id)}>{label}</Button>
        ))}
        <Button size="small" href={zavvyUsage.csvUrl()} target="_blank">CSV export</Button>
      </Box>
      {error ? <Typography color="error">{error}</Typography> : null}
      <Box component="pre" sx={{ whiteSpace: 'pre-wrap', fontSize: 12 }}>{JSON.stringify(data, null, 2)}</Box>
      <Typography variant="h6">Limits</Typography>
      <Typography variant="body2">Null means unlimited.</Typography>
      <Box component="pre" sx={{ fontSize: 12 }}>{JSON.stringify(limits, null, 2)}</Box>
      <LimitsEditor onSave={(body) => zavvyUsage.putLimits(body).then(() => zavvyUsage.limits().then((res) => setLimits(res.data)))} />
      <Typography variant="h6">Prices</Typography>
      <Box component="pre" sx={{ fontSize: 12 }}>{JSON.stringify(prices, null, 2)}</Box>
    </Box>
  );
}

function LimitsEditor({ onSave }) {
  const [turns, setTurns] = useState('');
  return (
    <Box sx={{ display: 'flex', gap: 1, my: 1 }}>
      <TextField size="small" label="Monthly turn limit (blank = unlimited)" value={turns} onChange={(e) => setTurns(e.target.value)} />
      <Button onClick={() => onSave({ monthly_turns: turns === '' ? null : Number(turns) })}>Save default limits</Button>
    </Box>
  );
}
